export default "__VITE_ASSET__BYsFLe14__"